import { PolicyTypeCd, TypeOfPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { SvgIconProps } from '@mui/material';

import CondoIcon from '../assets/icons/Condo';
import House from '../assets/icons/House';
import LandlordIcon from '../assets/icons/Landlord';
import RentersIcon from '../assets/icons/Renters';
import Sedan from '../assets/icons/Sedan';
import Umbrella from '../assets/icons/Umbrella';

import type { JSX } from 'react';

export type PolicyTypeMapType = {
  [key in TypeOfPolicy | string]: {
    title: string;
    icon: ({ viewBox, ...props }: SvgIconProps) => JSX.Element;
  };
};

export const policyTypeMap: PolicyTypeMapType = {
  Home: { title: 'Homeowners', icon: House },
  PA: { title: 'Auto', icon: Sedan },
  SIG: { title: 'Auto', icon: Sedan },
  SEL: { title: 'Auto', icon: Sedan },
  PU: { title: 'Personal Umbrella', icon: Umbrella },
  PUP: { title: 'Personal Umbrella', icon: Umbrella },
  Renter: { title: 'Renters', icon: RentersIcon },
  Condo: { title: 'Condominium', icon: CondoIcon },
  Rental: { title: 'Landlord', icon: LandlordIcon },
  HO3: { title: 'Homeowners', icon: House },
  HO4: { title: 'Renters', icon: RentersIcon },
  HO6: { title: 'Condominium', icon: CondoIcon },
  DP3: { title: 'Landlord', icon: LandlordIcon },
};

export const policyTypeMapSelector = (
  policyType: PolicyTypeCd,
  fullProductCode: string
): string => {
  return ['PA', 'PU'].includes(policyType) ? policyType : fullProductCode;
};
